(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaa9f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaa9f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hwncm", function(module, exports) {
const wrapper = document.querySelector('[section-stores-list]');
if (!wrapper) return;
const storeGrid = document.querySelector('.store__grid');
const searchInput = document.querySelector('#search');
const storeNotFoundEl = document.querySelector('.store__grid--not-found');
if (!storeGrid || !searchInput) return;
let allStores;
let currentSeachVal;
init();
async function init() {
    renderStoreItems(await findAllStores());
    addEventListeners();
}
async function findAllStores() {
    function csvToArray(csv) {
        const lines = csv.split('\n');
        const headers = lines[0].split(',');
        return lines.slice(1).map((line)=>{
            const values = line.split(',');
            return headers.reduce((obj, header, index)=>{
                obj[header] = values[index];
                return obj;
            }, {});
        });
    }
    const csvUrl = wrapper.getAttribute('data-stores-list-url');
    const csv = await fetch(csvUrl);
    if (!csv) {
        console.error('Error fetching CSV:', error);
        failToRender = true;
        storeGrid.innerHTML = 'Fail to render stores';
        return;
    }
    const csvData = await csv.text();
    allStores = csvToArray(csvData);
    return allStores;
}
function storesNotFound(storeNotFound) {
    if (!storeNotFoundEl) return;
    if (storeNotFound) {
        storeNotFoundEl.classList.remove('d-none');
        const searchTerm = storeNotFoundEl.querySelector('[search-term]');
        if (!searchTerm) return;
        searchTerm.innerText = currentSeachVal;
    } else storeNotFoundEl.classList.add('d-none');
}
function renderStoreItems(results) {
    if (currentSeachVal === undefined || currentSeachVal.length === 0) storeGrid.classList.add('d-none');
    else if (storeGrid.classList.contains('d-none')) storeGrid.classList.remove('d-none');
    if (results.length === 0) storesNotFound(true);
    else storesNotFound(false);
    const storeItemTemplate = wrapper.querySelector('template.store__grid--item-template').content;
    if (!storeItemTemplate) return;
    storeGrid.innerHTML = '';
    results.map(function(store) {
        const storeItem = storeItemTemplate.cloneNode(true);
        storeItem.querySelector('.store__item--title').innerText = store.Name;
        const storeItemAddress = storeItem.querySelector('.store__item--address');
        storeItemAddress.innerHTML = `${store.Address?.trim()} <br> ${store["Postal code"]} ${store.City}`;
        if (store.Website.includes('https://')) {
            storeItem.querySelector('.store__item--web-url').setAttribute('href', store.Website);
            const webSiteName = store.Website.replace(/^https:\/\//, '');
            storeItem.querySelector('.store__item--web-url').innerText = webSiteName;
        }
        if (store.Address != '') {
            storeItem.querySelector('.store__item--map-url').setAttribute('href', `https://www.google.com/maps?q=${store.Address} + ${store.City || ''} + ${store['Postal code'] || ''}`);
            storeItem.querySelector('.store__item--map-url').classList.remove('d-none');
        }
        storeGrid.append(storeItem);
    });
}
function addEventListeners() {
    let searchValue = searchInput.value;
    searchInput.addEventListener('input', function(event) {
        if (event.target.value.length < 3) {
            searchValue = '';
            currentSeachVal = '';
        } else {
            currentSeachVal = event.target.value;
            searchValue = event.target.value.toLowerCase();
        }
        utilizeSearch(searchValue);
    });
}
function utilizeSearch(searchValue) {
    const searchedStores = searchStores(searchValue, allStores);
    renderStoreItems(searchedStores);
}
function searchStores(searchValue, filteredStores) {
    let searchedStores = [];
    const lowerSearch = searchValue.toLowerCase();
    filteredStores.forEach((store)=>{
        if (!store) return;
        const storeAddress = store?.Adress;
        const storeCity = store?.City;
        const storeName = store?.Name;
        const storePostalCode = store['Postal code'];
        if (storeAddress && storeAddress.toLowerCase().includes(lowerSearch) || storeCity && storeCity.toLowerCase().includes(lowerSearch) || storeName && storeName.toLowerCase().includes(lowerSearch) || storePostalCode && storePostalCode.toLowerCase().includes(lowerSearch)) searchedStores.push(store);
    });
    return searchedStores;
}

});

parcelRegister("ePZmj", function(module, exports) {
let membershipCheckbox = document.getElementById('cherryClub');
let newsletterCheckbox = document.getElementById('newsletter');
let promoProfileUpdateForm = document.querySelector('.account-main__promo-block-form-element');
if (!membershipCheckbox || !newsletterCheckbox || !promoProfileUpdateForm) return;
let btn = document.querySelector('.account-main__promo-block-submit');
function checkboxCheck() {
    if (membershipCheckbox.checked && newsletterCheckbox.checked) btn.disabled = false;
    else btn.disabled = true;
}
window.addEventListener("load", ()=>{
    checkboxCheck();
    membershipCheckbox.addEventListener('change', function() {
        checkboxCheck();
    });
    newsletterCheckbox.addEventListener('change', function() {
        checkboxCheck();
    });
});
if (promoProfileUpdateForm) // Add an event listener for form submission
promoProfileUpdateForm.addEventListener("submit", function(event) {
    // Prevent the default form submission
    event.preventDefault();
    if (membershipCheckbox.checked && newsletterCheckbox.checked) {
        const makeApiRequest = (url, data)=>{
            return fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });
        };
        const updateMarketingPermissionUrl = `https://konges-sloejd-middleman.vercel.app/api/update-marketing-permission/${theme.customer_club.store}`;
        const updateCustomerClubUrl = `https://konges-sloejd-middleman.vercel.app/api/update-customer-club/${theme.customer_club.store}`;
        const marketingRequestData = {
            customer: window.customer.id,
            email: window.customer.email,
            status: newsletterCheckbox.checked
        };
        const customerClubRequestData = {
            customer: window.customer.id,
            email: window.customer.email,
            status: membershipCheckbox.checked
        };
        Promise.all([
            makeApiRequest(updateMarketingPermissionUrl, marketingRequestData),
            makeApiRequest(updateCustomerClubUrl, customerClubRequestData)
        ]).then(()=>{
            location.reload();
        });
    }
});

});

parcelRegister("8582c", function(module, exports) {
const text1 = document.getElementById('embroidery_add');
const text2 = document.getElementById('embroidery_text');
if (!text1 || !text2) return;
const checkboxWrapper = document.querySelector('.product-embroidery .form-field__checkbox');
const inputError = document.querySelector('[data-embroidery-error]');
const ERROR_VISIBLE_MS = 2000;
let errorTimer = null;
/**
 * Allow-list: Latin letters (including accented ones such as æ ø å ä ö ü é)
 * and spaces, the only characters the embroidery machine can stitch.
 * Everything else is stripped: digits, punctuation, symbols, other scripts
 * (Cyrillic, Greek, Arabic, CJK, ...), emoji, joiners, < > and nulls.
 */ const disallowedRegex = /[^\p{Script=Latin} ]/gu;
text2.addEventListener('input', ()=>handleInput());
text1.addEventListener('change', ()=>copyTextValue());
/** Normalises accents to precomposed form, then removes every disallowed character. */ function sanitizeEmbroideryText(value) {
    return value.normalize('NFC').replace(disallowedRegex, '');
}
function hasDisallowedCharacters(value) {
    return sanitizeEmbroideryText(value) !== value.normalize('NFC');
}
function showInputError() {
    if (!inputError) return;
    inputError.classList.add('is-expanded');
    clearTimeout(errorTimer);
    errorTimer = setTimeout(()=>{
        inputError.classList.remove('is-expanded');
    }, ERROR_VISIBLE_MS);
}
function copyTextValue(e) {
    const text2Value = text2.value;
    const charEL = document.querySelector('.product-embroidery_char span');
    if (checkboxWrapper) {
        if (text2Value) checkboxWrapper.classList.remove('form-field__checkbox--disabled');
        else {
            text1.checked = false;
            checkboxWrapper.classList.add('form-field__checkbox--disabled');
        }
    }
    if (charEL) charEL.innerHTML = text2Value.length;
    text1.value = text1.checked ? text2Value : '';
}
function handleInput() {
    const raw = text2.value;
    const sanitized = sanitizeEmbroideryText(raw);
    if (sanitized !== raw) text2.value = sanitized;
    if (hasDisallowedCharacters(raw)) showInputError();
    copyTextValue();
}
window.addEventListener('load', function() {
    handleInput();
});

});

parcelRegister("dKEAy", function(module, exports) {
let targets = document.querySelectorAll('.product-info-variants__container');
if (!targets.length) return;
function controlItemsVisibility(target, targetHeight) {
    let pickers = target.querySelectorAll('.product-info-variants__picker');
    pickers.forEach(function(picker, index) {
        let pickerRect = picker.getBoundingClientRect();
        let containerRect = target.getBoundingClientRect();
        let relativePosition = {
            top: pickerRect.top - containerRect.top
        };
        if (relativePosition.top > targetHeight) picker.classList.toggle('d-none');
    });
    let hiddenItems = target.querySelectorAll('.product-info-variants__picker.d-none');
    if (hiddenItems.length > 0) {
        target.querySelector('.product-info-variants__picker--see-all')?.classList?.remove('d-none');
        target.querySelector('.product-info-variants__picker--see-all')?.classList?.add('visible');
        //hide last visible element
        let visibleItems = target.querySelectorAll('.product-info-variants__picker.regular-item:not(d-none)');
        if (visibleItems.length) {
            visibleItems[visibleItems.length - hiddenItems.length]?.classList?.add('d-none');
            visibleItems[visibleItems.length - hiddenItems.length - 1]?.classList?.add('d-none');
        }
    }
    target.classList.add('ready');
    updateHeightOfVariantsWrapperEl(target);
}
function runCheck() {
    targets = document.querySelectorAll('.product-info-variants__container');
    targets.forEach(function(target) {
        let targetHeight = target.offsetHeight;
        let productVariantsWrapper = target.querySelector('.product-info-variants__wrapper');
        if (productVariantsWrapper) {
            // Get the height of the product-info-variants__wrapper
            let productVariantsWrapperHeight = productVariantsWrapper.offsetHeight;
            if (targetHeight < productVariantsWrapperHeight) controlItemsVisibility(target, targetHeight);
            else target.classList.add('ready');
        }
    });
    updateHeightOfVariantsWrapperElMain();
}
function updateHeightOfVariantsWrapperElMain() {
    const variantsWrapperArr = document.querySelectorAll('.product-info-variants__container.ready');
    variantsWrapperArr.forEach((el)=>{
        updateHeightOfVariantsWrapperEl(el);
    });
}
function updateHeightOfVariantsWrapperEl(el) {
    if (el === null || el === undefined) return;
    const variantContent = el.querySelector('.product-info-variants__container--inner');
    if (variantContent == null) return;
    const variantContentHeight = variantContent.offsetHeight;
    el.style.maxHeight = parseInt(variantContentHeight) + 32 + 'px';
    const elInner = el.querySelector('.product-info-variants__wrapper');
    if (window.innerWidth < 750) {
        if (elInner.offsetWidth < elInner.scrollWidth) {
            el?.classList.add('mobile_variants-overflown');
            const boundingBox = el.getBoundingClientRect();
            const afterLeftEdge = boundingBox.right - 25;
            el.querySelectorAll('.product-info-variants__wrapper a').forEach((aLink)=>{
                const afterLeftEdgeWithProductWith = afterLeftEdge;
                const aLinkDimensions = aLink.getBoundingClientRect().right;
                if (aLinkDimensions > afterLeftEdgeWithProductWith) aLink.classList.add('d-none');
            });
            el.addEventListener('click', function(el2) {
                if (event.clientX >= afterLeftEdge && event.clientX <= boundingBox.right) {
                    const productLinkEl = el?.closest('.product-item__info')?.querySelector('a.product-link');
                    if (productLinkEl === null || productLinkEl === undefined) return;
                    const productLink = productLinkEl.getAttribute('data-product-link');
                    window.location.href = productLink;
                }
            });
        }
    }
}
window.onload = function() {
    if (document.querySelectorAll('.product-info-variants__container.ready').length > 0) setTimeout(()=>{
        updateHeightOfVariantsWrapperEl();
    }, 0);
};
window.addEventListener("resize", runCheck);
document.addEventListener("DOMContentLoaded", runCheck);
window.addEventListener("theme:filter:update", runCheck);

});

/*
 * Shopify Common JS
 *
 */ /* global Shopify, SmartWishlistScripts */ if (typeof window.Shopify === 'undefined') window.Shopify = {};
Shopify.postLink = function postLink(path, options = {}) {
    const method = options.method || 'post';
    const params = options.parameters || {};
    const form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);
    Object.keys(params).forEach((key)=>{
        const hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};
// wishlist bug fix for related/recently viewed products
const $37fe43caa1796795$var$recentWrappers = document.querySelectorAll('[data-recent-wrapper]');
if ($37fe43caa1796795$var$recentWrappers.length > 0) $37fe43caa1796795$var$recentWrappers.forEach((recentWrapper)=>{
    const options = {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
    };
    function mCallback(mutations) {
        mutations.forEach((mutation)=>{
            if (mutation.type === 'childList' && mutation.target.nodeName === 'DIV' && typeof SmartWishlistScripts === 'function') SmartWishlistScripts();
        });
    }
    const observer = new MutationObserver(mCallback);
    observer.observe(recentWrapper, options);
});


function $6595e751cfc67eca$var$subscribe(listId, email, params = {}) {
    const config = Object.assign({}, params, {
        g: listId,
        email: email
    });
    const body = Object.keys(config).reduce((str, key)=>{
        str.append(key, config[key]);
        return str;
    }, new URLSearchParams());
    return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: {
            "Access-Control-Allow-Headers": "*",
            "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
        },
        body: body
    }).then((res)=>res.json());
}
const $6595e751cfc67eca$var$backinstockWrapper = document.querySelector('[data-back-in-stock]');
function $6595e751cfc67eca$var$runBackInStock(params) {
    if (!$6595e751cfc67eca$var$backinstockWrapper) return;
    const backinstockForm = $6595e751cfc67eca$var$backinstockWrapper.querySelector('[data-form]');
    if (!backinstockForm) return;
    const backinstockSuccess = document.querySelector('[data-bis-success]');
    const formEmail = backinstockForm.querySelector('#bis-email');
    const formNewsletter = backinstockForm.querySelector('#bis-newsletter');
    const formSubmitButton = backinstockForm.querySelector('button[type="submit"]');
    const errorMessage = backinstockForm.querySelector('#bis-error-message');
    backinstockForm.addEventListener('submit', async (e)=>{
        e.preventDefault();
        if (formNewsletter.checked === false) {
            errorMessage.style.display = "block";
            return;
        }
        errorMessage.style.display = "none";
        const chosenVariantEl = document.querySelector('.product__content .form__width input[name="id"]');
        if (!chosenVariantEl) return;
        let chosenVariant = chosenVariantEl.value;
        formSubmitButton.disabled = true;
        if (chosenVariant === '') {
            formSubmitButton.disabled = false;
            return;
        }
        const backInStockURL = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${theme.settings.klaviyoAccount}`;
        const dataJSON = JSON.stringify({
            data: {
                type: 'back-in-stock-subscription',
                attributes: {
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: {
                                email: formEmail.value
                            }
                        }
                    },
                    channels: [
                        "EMAIL"
                    ]
                },
                relationships: {
                    variant: {
                        data: {
                            type: 'catalog-variant',
                            id: `$shopify:::$default:::${chosenVariant}`
                        }
                    }
                }
            }
        });
        const options = {
            method: 'POST',
            headers: {
                accept: 'application/vnd.api+json',
                revision: '2025-01-15',
                'content-type': 'application/vnd.api+json'
            },
            body: dataJSON
        };
        const outOfStockDrawer = document.querySelector('#out-of-stock-drawer');
        if (outOfStockDrawer.getAttribute('data-modal-type') !== 'notify-me') try {
            await fetch(backInStockURL, options).then((res)=>res).catch((err)=>console.error(err));
            if (formNewsletter.checked) {
                const subscribeURL = `https://a.klaviyo.com/client/subscriptions/?company_id=${theme.settings.klaviyoAccount}`;
                let subscribeOptions;
                subscribeOptions = {
                    method: 'POST',
                    headers: {
                        revision: '2025-01-15',
                        'content-type': 'application/vnd.api+json',
                        'accept': 'application/vnd.api+json'
                    },
                    body: JSON.stringify({
                        data: {
                            type: 'subscription',
                            attributes: {
                                profile: {
                                    data: {
                                        type: 'profile',
                                        attributes: {
                                            email: formEmail.value,
                                            properties: {
                                                custom_source: 'Back in Stock'
                                            }
                                        }
                                    }
                                }
                            },
                            relationships: {
                                list: {
                                    data: {
                                        type: 'list',
                                        id: theme.settings.klaviyoList
                                    }
                                }
                            }
                        }
                    })
                };
                await fetch(subscribeURL, subscribeOptions).then((res)=>res).catch((err)=>console.error('error:' + err));
            }
        } catch (e) {
            console.warn("Error:", e);
        }
        $6595e751cfc67eca$var$backinstockWrapper.classList.remove('is-open');
        formSubmitButton.disabled = false;
        backinstockSuccess.hidden = false;
    });
}
if ($6595e751cfc67eca$var$backinstockWrapper) $6595e751cfc67eca$var$runBackInStock();


window.addEventListener("load", function() {
    document.body.addEventListener('click', function(event) {
        if (event.target && event.target.classList.contains('btn')) {
            const btn = event.target;
            const recommended_product = btn.closest(".cart_recommendation_product__form");
            if (recommended_product) $9e64ed48514e564e$var$sendRecommendedProductForm(btn);
        }
    });
});
async function $9e64ed48514e564e$var$sendRecommendedProductForm(btn) {
    document.dispatchEvent(new CustomEvent("theme:cart:add", {
        detail: {
            button: btn
        }
    }));
}


let $7bfb7ea1eda815ec$var$outOfStockWrapper = document.getElementById("out-of-stock-drawer");
if ($7bfb7ea1eda815ec$var$outOfStockWrapper) {
    let activeVariantId = document.querySelector('.form__width input[name="id"]').value;
    const productElemJSON = document.querySelector('[data-product-json]');
    let productJSON = productElemJSON.innerHTML;
    productJSON = JSON.parse(productJSON);
    function returnActiveVariantName(activeVariantId) {
        let variant = productJSON.variants.find((variant)=>variant.id == activeVariantId);
        return variant.title;
    }
    function closeDrawer() {
        $7bfb7ea1eda815ec$var$outOfStockWrapper.classList.remove('is-open');
        $7bfb7ea1eda815ec$var$outOfStockWrapper?.removeAttribute('data-modal-type');
        document.querySelector('body').classList.remove('scroll-lock');
        $7bfb7ea1eda815ec$var$outOfStockWrapper.querySelector('.backinstock-btn').classList.remove('d-none');
        $7bfb7ea1eda815ec$var$outOfStockWrapper.querySelector('.notify-me-btn').classList.add('d-none');
    }
    //close drawer
    document.querySelector('#out-of-stock-drawer .drawer__underlay').addEventListener('click', function() {
        closeDrawer();
    });
    document.querySelector('#out-of-stock-drawer .drawer__close').addEventListener('click', function() {
        closeDrawer();
    });
    let watcher = document.querySelector('.form__width input[name="id"]');
    watcher.addEventListener('change', function() {
        activeVariantId = this.value;
        document.querySelector('.product__selected-size--value').innerHTML = returnActiveVariantName(activeVariantId);
    });
}


const $f70996098ebdf748$var$container = document.querySelector('.product__slides.product-single__photos');
if ($f70996098ebdf748$var$container) {
    let target = document.querySelector('.product-single__slide-counter--current');
    const images = document.querySelectorAll('.product__slide');
    const options = {
        rootMargin: '0px',
        threshold: 1.0
    };
    const doThings = (entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) target.innerHTML = entry.target.dataset.imgIndex;
        });
    };
    const observer = new IntersectionObserver(doThings, {
        ...options,
        threshold: 0.4
    });
    images.forEach((target)=>{
        observer.observe(target);
    });
}


let $e67fb2ceb937a48b$var$customSelects = document.getElementsByClassName("custom-select");
if ($e67fb2ceb937a48b$var$customSelects.length) {
    // Loop through each custom-select element:
    Array.from($e67fb2ceb937a48b$var$customSelects).forEach((customSelect)=>{
        let selectElement = customSelect.getElementsByTagName("select")[0];
        // Create a DIV for the selected item:
        let selectedDiv = document.createElement("DIV");
        selectedDiv.className = "select-selected";
        selectedDiv.innerHTML = "<span>" + selectElement.options[selectElement.selectedIndex].innerHTML + "</span>";
        customSelect.appendChild(selectedDiv);
        // Create a DIV for the option list:
        let optionsDiv = document.createElement("DIV");
        optionsDiv.className = "select-items select-hide";
        // Loop through each option in the select element:
        Array.from(selectElement.options).forEach((option, j)=>{
            let optionDiv = document.createElement("DIV");
            optionDiv.innerHTML = option.innerHTML;
            optionDiv.dataset.variant = option.value;
            // Add click event listener to update the select box:
            optionDiv.addEventListener("click", function(e) {
                selectElement.selectedIndex = j;
                selectedDiv.innerHTML = "<span>" + this.innerHTML + "</span>";
                let sameAsSelected = this.parentNode.getElementsByClassName("same-as-selected");
                Array.from(sameAsSelected).forEach((s)=>s.classList.remove("same-as-selected"));
                this.classList.add("same-as-selected");
                document.getElementById('upsell-variant').value = this.dataset.variant;
                selectedDiv.click();
            });
            optionsDiv.appendChild(optionDiv);
        });
        customSelect.appendChild(optionsDiv);
        // Add click event listener to toggle the select box:
        selectedDiv.addEventListener("click", function(e) {
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
        });
    });
    // Function to close all select boxes except the current one:
    function closeAllSelect(elmnt) {
        let selects = document.getElementsByClassName("select-items");
        let selectedDivs = document.getElementsByClassName("select-selected");
        Array.from(selectedDivs).forEach((selectedDiv)=>{
            if (elmnt != selectedDiv) selectedDiv.classList.remove("select-arrow-active");
        });
        Array.from(selects).forEach((select)=>{
            if (elmnt != select.previousSibling) select.classList.add("select-hide");
        });
    }
    // Close all select boxes when the user clicks anywhere outside:
    document.addEventListener("click", closeAllSelect);
}


parcelRequire("hwncm");
function $b9058744ac81d82b$var$handleizeTag(value) {
    return String(value).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}
function $b9058744ac81d82b$export$ee3c11e1fb9d2dd0(product) {
    if (!product?.tags?.length) return false;
    return product.tags.some((tag)=>$b9058744ac81d82b$var$handleizeTag(tag) === 'coming-soon');
}
function $b9058744ac81d82b$var$cartHasComingSoonProducts() {
    if (document.querySelector('[data-cart-form][data-cart-has-coming-soon="true"]')) return true;
    return document.querySelector('[data-product-coming-soon="true"]') !== null;
}
function $b9058744ac81d82b$var$isComingSoonAddToCartTarget(button) {
    if (!button) return false;
    const productSection = button.closest('[data-section-type="product"]');
    if (productSection?.getAttribute('data-coming-soon') === 'true') return true;
    const quickAddHolder = button.closest('[data-quick-add-holder]');
    if (quickAddHolder?.getAttribute('data-coming-soon') === 'true') return true;
    const recommendationForm = button.closest('.cart_recommendation_product__form');
    if (recommendationForm?.getAttribute('data-coming-soon') === 'true') return true;
    return false;
}
function $b9058744ac81d82b$var$updateCheckoutButtons() {
    const hasComingSoon = $b9058744ac81d82b$var$cartHasComingSoonProducts();
    document.querySelectorAll('[data-cart-checkout-buttons]').forEach((wrapper)=>{
        const fieldset = wrapper.querySelector('[data-cart-checkout-button]');
        const checkoutButton = fieldset?.querySelector('button[name="checkout"]');
        const error = wrapper.parentElement?.querySelector('[data-coming-soon-error-message]') || wrapper.querySelector('[data-coming-soon-error-message]');
        const termsCheckbox = document.querySelector('[data-cart-acceptance-checkbox]');
        const termsBlocking = termsCheckbox && !termsCheckbox.checked;
        if (hasComingSoon) {
            wrapper.classList.add('cart__buttons--disabled');
            fieldset?.setAttribute('disabled', 'disabled');
            checkoutButton?.setAttribute('disabled', 'disabled');
            error?.classList.add('is-expanded');
            return;
        }
        error?.classList.remove('is-expanded');
        if (!termsBlocking) {
            wrapper.classList.remove('cart__buttons--disabled');
            fieldset?.removeAttribute('disabled');
            checkoutButton?.removeAttribute('disabled');
        }
    });
    document.querySelectorAll('[data-cart-form]').forEach((form)=>{
        form.setAttribute('data-cart-has-coming-soon', hasComingSoon ? 'true' : 'false');
    });
}
function $b9058744ac81d82b$var$bindCartForms() {
    document.querySelectorAll('[data-cart-form]').forEach((form)=>{
        if (form.dataset.comingSoonBound === 'true') return;
        form.dataset.comingSoonBound = 'true';
        form.addEventListener('submit', (event)=>{
            if (!$b9058744ac81d82b$var$cartHasComingSoonProducts()) return;
            const submitter = event.submitter;
            if (submitter?.name === 'checkout') {
                event.preventDefault();
                $b9058744ac81d82b$var$updateCheckoutButtons();
            }
        });
    });
}
document.addEventListener('theme:cart:add', (event)=>{
    if ($b9058744ac81d82b$var$isComingSoonAddToCartTarget(event.detail?.button)) {
        event.stopImmediatePropagation();
        event.preventDefault();
    }
}, true);
function $b9058744ac81d82b$var$initComingSoonCartGuards() {
    $b9058744ac81d82b$var$bindCartForms();
    $b9058744ac81d82b$var$updateCheckoutButtons();
}
document.addEventListener('theme:cart:change', $b9058744ac81d82b$var$initComingSoonCartGuards);
document.addEventListener('theme:cart:drawer:update', $b9058744ac81d82b$var$initComingSoonCartGuards);
document.addEventListener('DOMContentLoaded', $b9058744ac81d82b$var$initComingSoonCartGuards);


function $12afc4d4b2745b3d$var$applyComingSoonWishlistCta(element) {
    element.querySelector('[data-add-to-cart]')?.remove();
    const submitItem = element.querySelector('.product__submit__item');
    if (!submitItem) return;
    const disabledBtn = document.createElement('button');
    disabledBtn.type = 'button';
    disabledBtn.className = 'btn btn--primary btn--solid sold-out-button';
    disabledBtn.disabled = true;
    disabledBtn.innerHTML = `<span class="btn__text">${window.theme?.strings?.comingSoon || 'Coming soon'}</span>`;
    submitItem.appendChild(disabledBtn);
    element.querySelector('[data-product-form]')?.addEventListener('submit', (event)=>{
        event.preventDefault();
    });
}
const $12afc4d4b2745b3d$var$sectionCheck = document.querySelector('.wishlist-section');
if ($12afc4d4b2745b3d$var$sectionCheck) {
    function fireWhenReady() {
        if (typeof SmartWishlistMain != 'undefined') $12afc4d4b2745b3d$var$wishlistInit();
        else setTimeout(fireWhenReady, 100);
    }
    fireWhenReady();
}
function $12afc4d4b2745b3d$var$wishlistInit() {
    //This jQuery based code fetches the contents of Express Wishlist (unregistered users)
    let customerid = SWGetCustomerWishlistId();
    let wishlistid = customerid !== 0 ? customerid : SWGetExpressWishlistId();
    let idParam = customerid !== 0 ? `customerid` : `wishlistid`;
    jQuery.ajax({
        url: `/a/wishlist?type=api&${idParam}=${wishlistid}&version=1`,
        dataType: 'json',
        cache: false,
        success: function(data) {
            if (data.count < 1) document.querySelector('.wishlist__empty').removeAttribute('hidden');
            else {
                $12afc4d4b2745b3d$var$displayItems(data.items);
                document.querySelector('.grid').removeAttribute('hidden');
                //copy wishlist link to clipboard
                const shareWishlistButtons = document.querySelectorAll('.wishlist-share');
                shareWishlistButtons.forEach((btn)=>{
                    btn.addEventListener('click', ()=>{
                        const wishlistURL = `${window.location.origin}/a/wishlist/${wishlistid}`;
                        navigator.clipboard.writeText(wishlistURL).then(()=>{
                            btn.innerText = btn.dataset.text;
                        });
                    });
                });
            }
        }
    });
}
function $12afc4d4b2745b3d$var$buildSizeDropdown(productID, variantID, variantTitle, variants) {
    let targets = document.querySelectorAll(`[data-product-id='${productID}'] .select-items`);
    variants.forEach((variant)=>{
        if (variant.available) {
            let opt = document.createElement('div');
            opt.dataset.variant = variant.id;
            opt.innerHTML = variant.title;
            targets.forEach((target)=>{
                target.appendChild(opt.cloneNode(true));
            });
        }
    });
}
// Function to close all select boxes except the current one:
function $12afc4d4b2745b3d$var$closeAllSelect(elmnt) {
    let selects = document.getElementsByClassName('select-items');
    let selectedDivs = document.getElementsByClassName('select-selected');
    Array.from(selectedDivs).forEach((selectedDiv)=>{
        if (elmnt != selectedDiv) selectedDiv.classList.remove('select-arrow-active');
    });
    Array.from(selects).forEach((select)=>{
        if (elmnt != select.previousSibling) select.classList.add('select-hide');
    });
}
async function $12afc4d4b2745b3d$var$displayItems(items) {
    let temp = document.getElementById('wishlist-item-template');
    if (!temp) {
        console.error('Wishlist item template not found');
        return;
    }
    let itemx = temp.content.querySelector('div');
    if (!itemx) {
        console.error('Wishlist item template content is empty or missing div');
        return;
    }
    // Fetch product data for all items in parallel and append variants to each item
    await Promise.all(items.map(async (item)=>{
        try {
            const res = await fetch(window.Shopify.routes.root + `products/${item.handle}.js`);
            if (!res.ok) throw new Error('Failed to fetch product data');
            const productData = await res.json();
            item.variants = productData.variants || [];
            item.tags = productData.tags || [];
            item.variant_price = productData.variants[0].price / 100;
        } catch (err) {
            item.variants = [];
            console.error(`Failed to fetch variants for ${item.handle}:`, err);
        }
    }));
    items.forEach((item)=>{
        let productID = item.id;
        let productTitle = item.title;
        let productPrice = item.variant_price;
        let variantID = item.variant_id;
        let variantTitle = item.variant_title;
        let productHandle = item.handle;
        let firstImage = item.image;
        newElement = document.importNode(itemx, true);
        const btn = newElement.querySelector('.product__submit__item .btn');
        newElement.querySelector('.product-item__title').innerHTML = productTitle;
        newElement.querySelector('.smartwishlist').dataset.product = productID;
        newElement.querySelector('.custom-select').dataset.productId = productID;
        newElement.querySelector('.product-cta').dataset.productId = productID;
        if (btn) {
            btn.dataset.productId = productID;
            btn.dataset.variantId = variantID;
        }
        newElement.querySelector('.smartwishlist').dataset.variant = variantID;
        newElement.querySelectorAll('.product-link').forEach((link)=>{
            link.setAttribute('href', `/products/${productHandle}`);
        });
        newElement.querySelector('.wishlist-thumbnail').setAttribute('src', firstImage);
        let srcset = newElement.querySelector('.wishlist-thumbnail').getAttribute('srcset');
        srcset = srcset.replaceAll('${firstImage}', firstImage);
        newElement.querySelector('.wishlist-thumbnail').setAttribute('srcset', srcset);
        newElement.querySelector('.money').innerHTML = window.Shopify.currency.active + ' ' + productPrice;
        if ((0, $b9058744ac81d82b$export$ee3c11e1fb9d2dd0)({
            tags: item.tags
        })) $12afc4d4b2745b3d$var$applyComingSoonWishlistCta(newElement);
        //default option
        newElement.querySelector(`.select-selected span`).innerHTML = variantTitle;
        newElement.querySelector("[name='id']").value = variantID;
        newElement.querySelector(`.select-selected`).addEventListener('click', function(e) {
            e.stopPropagation();
            this.classList.toggle('select-arrow-active');
            this.nextElementSibling.classList.toggle('select-hide');
        });
        //remove from grid if removed from wishlist
        newElement.querySelector('.smartwishlist').addEventListener('click', function() {
            this.closest('.grid-item').remove();
        });
        document.querySelector('.wishlist-section .grid').appendChild(newElement);
        $12afc4d4b2745b3d$var$buildSizeDropdown(productID, variantID, variantTitle, item.variants);
        ReloadSmartWishlist();
    });
}
document.addEventListener('click', function(e) {
    const target = e.target.closest('.select-items > div'); // Or any other selector.
    if (target) {
        //set dropdown text
        target.closest('.select-items').previousElementSibling.innerHTML = `<span>${target.innerHTML}</span>`;
        let x = target.closest('.custom-select').dataset.productId;
        document.querySelector(`[data-product-id='${x}'].btn`).dataset.variantId = target.dataset.variant;
        document.querySelector(`[data-product-id='${x}'].product-cta form input[name="id"] `).value = target.dataset.variant;
        $12afc4d4b2745b3d$var$closeAllSelect(this);
    }
});
// Close all select boxes when the user clicks anywhere outside:
document.addEventListener('click', $12afc4d4b2745b3d$var$closeAllSelect);


const $a7eae63dc0c2b458$var$notifyMeButton = document.querySelector('[data-open-notify-me-modal]');
const $a7eae63dc0c2b458$var$notifyMeModal = document.querySelector('#out-of-stock-drawer');
if ($a7eae63dc0c2b458$var$notifyMeButton && $a7eae63dc0c2b458$var$notifyMeModal) $a7eae63dc0c2b458$var$notifyMeButton.addEventListener('click', $a7eae63dc0c2b458$var$openNotifyMeModal);
function $a7eae63dc0c2b458$var$openNotifyMeModal(e) {
    e.preventDefault();
    const currButton = e.target;
    const notifyMeListId = currButton.dataset.klaviyoListId;
    const notifyMeCompanyId = currButton.dataset.klaviyoCompanyId;
    $a7eae63dc0c2b458$var$notifyMeModal.setAttribute('data-klaviyo-list-id', notifyMeListId);
    $a7eae63dc0c2b458$var$notifyMeModal.setAttribute('data-klaviyo-company-id', notifyMeCompanyId);
    $a7eae63dc0c2b458$var$notifyMeModal.setAttribute('data-modal-type', 'notify-me');
    $a7eae63dc0c2b458$var$notifyMeModal.querySelector('.backinstock-btn').classList.add('d-none');
    $a7eae63dc0c2b458$var$notifyMeModal.querySelector('.notify-me-btn').classList.remove('d-none');
    $a7eae63dc0c2b458$var$notifyMeModal.classList.add('is-open');
    if ($a7eae63dc0c2b458$var$notifyMeModal.getAttribute('data-modal-type') === 'notify-me') $a7eae63dc0c2b458$var$notifyMeModal.querySelector('form').addEventListener('submit', $a7eae63dc0c2b458$var$notifyMe);
}
async function $a7eae63dc0c2b458$var$notifyMe(e) {
    e.preventDefault();
    const email = $a7eae63dc0c2b458$var$notifyMeModal.querySelector('#bis-email').value;
    const klaviyoListId = $a7eae63dc0c2b458$var$notifyMeModal.getAttribute('data-klaviyo-list-id');
    const klaviyoCompanyId = $a7eae63dc0c2b458$var$notifyMeModal.getAttribute('data-klaviyo-company-id');
    if ($a7eae63dc0c2b458$var$notifyMeModal.querySelector('#bis-newsletter').checked != true) return;
    if (email && klaviyoListId) {
        const storeMap = {
            BE: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
            AU: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
            CA: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
            NZ: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
            KR: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
            AD: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
            DK: '94253566-5c4f-4050-88b8-5b5d045dded2',
            DE: '3933782f-b437-4319-9609-b9b3ad8e9c77',
            FR: 'c785a7b6-a885-4591-a80b-0c05148c54bf',
            NL: '437a9635-46eb-48a1-a0a3-78870a35c719',
            GB: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
            US: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
            NO: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
            SE: '4ce904e4-ef54-460c-96ab-d27f63c19e61'
        };
        const productJSON = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
        await fetch('https://int-shopify-service-production.up.railway.app/comingSoon/save', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
                'Access-Control-Allow-Methods': 'GET, PUT, POST, OPTIONS',
                'x-store-id': storeMap[window.theme.currentShop.countryCode],
                'x-tenant-id': 'e3ae5350-7f0a-4ca6-8aa2-ba1e14722531'
            },
            body: JSON.stringify({
                email: email,
                sendEvent: true,
                productId: 'gid://shopify/Product/' + productJSON.id,
                product: {
                    id: 'gid://shopify/Product/' + productJSON.id,
                    title: productJSON.title,
                    image: 'https:' + productJSON.featured_image,
                    collections: productJSON.tags,
                    price: productJSON.price / 100,
                    url: window.location.href,
                    sku: productJSON.variants[0].sku,
                    platform: 'shopify',
                    email: email
                },
                listId: klaviyoListId,
                companyId: klaviyoCompanyId
            })
        });
    }
}



parcelRequire("ePZmj");
const $2aae1bc150a038cc$var$giftId = window.theme.freeGift.variantId;
const $2aae1bc150a038cc$var$freeGiftLimit = window.theme.freeGift.limit;
const $2aae1bc150a038cc$var$freeShippingLimit = window.theme.freeShipping.limit;
$2aae1bc150a038cc$var$showProgressBarText(window.theme.subtotal);
function $2aae1bc150a038cc$var$showProgressBarText(total) {
    let defaultMessage = document.querySelectorAll(".free-shipping-gift__default-message");
    if (defaultMessage.length == 0) defaultMessage = document.querySelectorAll(".free-shipping__default-message");
    const firstMessage = document.querySelectorAll(".free-shipping-gift__first-message");
    let successMessage = document.querySelectorAll(".free-shipping-gift__success-message");
    if (successMessage.length == 0) successMessage = document.querySelectorAll(".free-shipping__success-message");
    let successMessageFreeShipping = document.querySelectorAll(".free-shipping__success-message");
    if (successMessageFreeShipping.length == 0) successMessageFreeShipping = document.querySelectorAll(".free-shipping__success-message");
    // Hide all messages initially
    if (defaultMessage) defaultMessage.forEach((message)=>{
        message.style.display = "none";
    });
    if (firstMessage) firstMessage.forEach((message)=>{
        message.style.display = "none";
    });
    if (successMessage) successMessage.forEach((message)=>{
        message.style.display = "none";
    });
    // Show the appropriate message based on the total
    if (total < $2aae1bc150a038cc$var$freeShippingLimit) {
        if (defaultMessage) defaultMessage.forEach((message)=>{
            message.style.display = "block";
        });
    } else if (total >= $2aae1bc150a038cc$var$freeShippingLimit && total < $2aae1bc150a038cc$var$freeGiftLimit) {
        if (firstMessage) firstMessage.forEach((message)=>{
            message.style.display = "block";
        });
    } else if (total >= $2aae1bc150a038cc$var$freeShippingLimit && !$2aae1bc150a038cc$var$freeGiftLimit) {
        if (successMessageFreeShipping) successMessageFreeShipping.forEach((message)=>{
            message.style.display = "block";
        });
    } else if (total >= $2aae1bc150a038cc$var$freeGiftLimit) {
        if (successMessage) successMessage.forEach((message)=>{
            message.style.display = "block";
        });
    }
}
document.addEventListener("theme:cart:change", async (event)=>{
    const { total: total, items: items } = event.detail;
    const isFreeGiftRemoved = localStorage.getItem("freeGiftRemoved");
    $2aae1bc150a038cc$var$showProgressBarText(total);
    if (!$2aae1bc150a038cc$var$freeGiftLimit) return;
    if (isFreeGiftRemoved) {
        localStorage.removeItem("freeGiftRemoved");
        return;
    }
    let itemsArray = Array.from(items.children);
    const hasGift = itemsArray?.find((item)=>{
        const variantId = +item.dataset.variantId;
        return variantId === $2aae1bc150a038cc$var$giftId;
    });
    const totalCartWithoutGift = total - (hasGift?.dataset?.price || 0);
    const hasReachedFreeGiftLimit = totalCartWithoutGift > $2aae1bc150a038cc$var$freeGiftLimit;
    if (hasReachedFreeGiftLimit && !hasGift) await $2aae1bc150a038cc$var$updateCart(1);
    const hasNotReachedFreeGiftLimit = totalCartWithoutGift <= $2aae1bc150a038cc$var$freeGiftLimit;
    if (hasNotReachedFreeGiftLimit && hasGift) await $2aae1bc150a038cc$var$updateCart(0);
});
async function $2aae1bc150a038cc$var$updateCart(quantity) {
    try {
        const response = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                updates: {
                    [$2aae1bc150a038cc$var$giftId]: quantity
                }
            })
        });
        // await response.json();
        document.dispatchEvent(new CustomEvent("theme:cart:drawer:update", {
            detail: {}
        }));
    } catch (error) {
        console.error("Error:", error);
    }
}


let $a9338c0939d13421$var$target = document.querySelector('.cart-giftbox');
if ($a9338c0939d13421$var$target) window.addEventListener("load", ()=>{
    if (window.location.href.includes("/cart")) return;
    let checkbox = document.querySelector(".cart-giftbox__switch");
    let variantID = document.querySelector('.cart-giftbox__button').dataset.id;
    if (checkbox && variantID) {
        if (document.querySelector(`.cart__item__remove[data-id*="${variantID}"]`)) {
            checkbox.setAttribute('checked', true);
            checkboxChecker();
        } else checkboxChecker();
        function checkboxChecker() {
            checkbox.addEventListener('change', function() {
                if (this.checked) {
                    let button = document.querySelector('.btn.cart-giftbox__button');
                    sendRecommendedProductForm(button);
                } else document.querySelector(`.cart__item__remove[data-id*="${variantID}"]`).click();
            });
        }
        async function sendRecommendedProductForm(btn) {
            document.dispatchEvent(new CustomEvent("theme:cart:add", {
                detail: {
                    button: btn
                }
            }));
        }
    }
});


let $5b2dead14d0bac60$var$addBirthdayToggle = document.querySelector('.customer__birthday-add-toggle');
let $5b2dead14d0bac60$var$addBirthdayCloseHeader = document.querySelector('.customer__birthday-add-header');
let $5b2dead14d0bac60$var$addBirthdayCloseButton = $5b2dead14d0bac60$var$addBirthdayCloseHeader?.querySelector('.customer__birthday-add-close');
let $5b2dead14d0bac60$var$addBirthdayForm = document.querySelector('.customer__birthday-add-form');
$5b2dead14d0bac60$var$addBirthdayToggle?.addEventListener('click', function() {
    $5b2dead14d0bac60$var$addBirthdayToggle.classList.toggle('d-none');
    $5b2dead14d0bac60$var$addBirthdayCloseHeader.classList.toggle('d-none');
    $5b2dead14d0bac60$var$addBirthdayForm.classList.toggle('d-none');
});
$5b2dead14d0bac60$var$addBirthdayCloseButton?.addEventListener('click', function() {
    $5b2dead14d0bac60$var$addBirthdayCloseHeader.classList.toggle('d-none');
    $5b2dead14d0bac60$var$addBirthdayToggle.classList.toggle('d-none');
    $5b2dead14d0bac60$var$addBirthdayForm.classList.toggle('d-none');
});
const $5b2dead14d0bac60$var$submitBirthday = async (button)=>{
    const birthdayElement = button.parentElement.parentElement;
    const spinner = birthdayElement.querySelector("[data-spinner]");
    button.disabled = true;
    const birthdayDateObject = new Date(birthdayElement.querySelector('input[type="date"]').value);
    const currentDate = new Date();
    if (birthdayDateObject > currentDate) {
        alert(window.theme.strings.birthday_future_select_error);
        button.disabled = false;
        return;
    }
    const birthdayObject = JSON.parse(birthdayElement.querySelector("[birthday-data]").innerHTML);
    const dateUnix = Math.floor(birthdayDateObject.getTime() / 1000);
    const newBirthday = {
        customer: window.customer.id,
        email: window.customer.email,
        properties: birthdayObject
    };
    newBirthday.properties.date = dateUnix;
    const response = await fetch(`https://konges-sloejd-middleman.vercel.app/api/update-property-fields/${theme.customer_club.store}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(newBirthday)
    }).then((r)=>r.json());
    button.disabled = false;
    birthdayElement.querySelector("[birthday-data]").innerHTML = JSON.stringify({
        ...birthdayObject,
        current_tag: response.current_tag
    });
};
const $5b2dead14d0bac60$var$currentBirthdayList = document.querySelector("[data-birthday-list]");
const $5b2dead14d0bac60$var$newBirthdayForm = document.querySelector("[data-new-birthday-form]");
const $5b2dead14d0bac60$var$newBirthdayButton = document.querySelector("[data-new-birthday]");
let $5b2dead14d0bac60$var$existingBirthdayInputs = $5b2dead14d0bac60$var$currentBirthdayList?.querySelectorAll('.customer__birthday--input');
$5b2dead14d0bac60$var$newBirthdayButton?.addEventListener("click", ()=>{
    $5b2dead14d0bac60$var$newBirthdayForm.setAttribute("data-active", "true");
    $5b2dead14d0bac60$var$newBirthdayButton.hidden = true;
});
$5b2dead14d0bac60$var$newBirthdayForm?.addEventListener("submit", async (e)=>{
    e.preventDefault();
    const currentBirthdays = document.querySelectorAll("[data-birthday]");
    const nameInput = $5b2dead14d0bac60$var$newBirthdayForm.querySelector("#new_birthday_name");
    const dateInput = $5b2dead14d0bac60$var$newBirthdayForm.querySelector("#new_birthday_date");
    if (nameInput.value === "" || dateInput.value === "") return;
    const birthdayDateObject = new Date(dateInput.value);
    const currentDate = new Date();
    if (birthdayDateObject > currentDate) {
        alert(window.theme.strings.birthday_future_select_error);
        return;
    }
    $5b2dead14d0bac60$var$newBirthdayForm.setAttribute("data-active", "false");
    const dateUnix = Math.floor(birthdayDateObject.getTime() / 1000);
    const newBirthday = {
        customer: window.customer.id,
        email: window.customer.email,
        properties: {
            field: currentBirthdays.length + 1,
            name: nameInput.value,
            date: dateUnix,
            current_tag: null
        }
    };
    await fetch(`https://konges-sloejd-middleman.vercel.app/api/update-property-fields/${theme.customer_club.store}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(newBirthday)
    }).then((response)=>{
        if (response.status === 200) return response.json();
        throw new Error("Something went wrong with the request");
    }).then((data)=>{
        const html = `
        <li class="customer__birthday--item" data-birthday>
          <h6 class="customer__address--title">${nameInput.value}</h6>
          <input 
            type="date"
            class="customer__birthday--input"
            value="${dateInput.value}"
            max="${theme.customer_club.date}"
          >
          <script birthday-data type="application/json">
            {
              "field": ${currentBirthdays.length + 1},
              "name": "${nameInput.value}",
              "date": "${dateUnix}",
              "current_tag": "${data.current_tag}"
            }
          </script>
        </li>
      `;
        $5b2dead14d0bac60$var$currentBirthdayList.insertAdjacentHTML("beforeend", html);
        nameInput.value = "";
        dateInput.value = "";
        if (currentBirthdays.length < 5) {
            $5b2dead14d0bac60$var$addBirthdayCloseHeader.classList.toggle('d-none');
            $5b2dead14d0bac60$var$addBirthdayToggle.classList.toggle('d-none');
            $5b2dead14d0bac60$var$addBirthdayForm.classList.toggle('d-none');
        } else {
            $5b2dead14d0bac60$var$addBirthdayCloseHeader.classList.add('d-none');
            $5b2dead14d0bac60$var$addBirthdayToggle.classList.add('d-none');
            $5b2dead14d0bac60$var$addBirthdayForm.classList.add('d-none');
        }
    }).then(()=>{
        $5b2dead14d0bac60$var$existingBirthdayInputs = $5b2dead14d0bac60$var$currentBirthdayList?.querySelectorAll('.customer__birthday--input');
        const newBirthdayInput = $5b2dead14d0bac60$var$existingBirthdayInputs[$5b2dead14d0bac60$var$existingBirthdayInputs?.length - 1];
        if (newBirthdayInput) $5b2dead14d0bac60$var$makeBirthdayInputEditable(newBirthdayInput);
    }).catch((error)=>console.error(error));
});
$5b2dead14d0bac60$var$existingBirthdayInputs?.forEach((birthdayInput)=>{
    $5b2dead14d0bac60$var$makeBirthdayInputEditable(birthdayInput);
});
function $5b2dead14d0bac60$var$makeBirthdayInputEditable(birthdayInput) {
    birthdayInput.addEventListener('blur', async (e)=>{
        const inputScriptTag = birthdayInput.nextElementSibling;
        let inputData;
        const birthdayDateObject = new Date(birthdayInput.value);
        const birthdayYear = birthdayDateObject.getFullYear();
        const currentDate = new Date();
        if (birthdayInput.value === "" || birthdayYear < 1900) return;
        const dateUnix = Math.floor(birthdayDateObject.getTime() / 1000);
        if (inputScriptTag?.tagName === "SCRIPT") {
            const json = inputScriptTag?.innerText;
            inputData = JSON.parse(json);
        }
        if (!inputData || Number(inputData.date) == dateUnix) return;
        if (birthdayDateObject > currentDate) {
            alert(window.theme.strings.birthday_future_select_error);
            return;
        }
        const editedBirthday = {
            customer: window.customer.id,
            email: window.customer.email,
            properties: {
                field: inputData.field,
                name: inputData.name,
                date: dateUnix,
                current_tag: inputData.current_tag
            }
        };
        await fetch(`https://konges-sloejd-middleman.vercel.app/api/update-property-fields/${theme.customer_club.store}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(editedBirthday)
        }).then((response)=>{
            if (response.status === 200) {
                alert(window.theme.strings.birthday_saved);
                return response.json();
            }
            throw new Error("Something went wrong with the request");
        });
    });
}


const $1c4bd05fc0a52288$var$customerClubStatus = document.querySelector('#customer-club');
const $1c4bd05fc0a52288$var$marketingStatus = document.querySelector('#marketing');
const $1c4bd05fc0a52288$var$updateCustomerClub = async (button, selector)=>{
    const checkbox = document.querySelector(`#${selector}`);
    if (!$1c4bd05fc0a52288$var$marketingStatus.checked && checkbox.checked) {
        alert(window.theme.strings.customer_club_unsubscribe_alert);
        checkbox.checked = false;
        return;
    }
    checkbox.disabled = true;
    button.disabled = true;
    await fetch(`https://konges-sloejd-middleman.vercel.app/api/update-customer-club/${theme.customer_club.store}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            customer: window.customer.id,
            email: window.customer.email,
            status: checkbox.checked
        })
    }).then((response)=>response).then(()=>{
        button.disabled = false;
        checkbox.disabled = false;
        $1c4bd05fc0a52288$var$customerClubStatus.checked = checkbox.checked;
    });
};
const $1c4bd05fc0a52288$var$updateMarketingPermission = async (button, selector)=>{
    const checkbox = document.querySelector(`#${selector}`);
    if ($1c4bd05fc0a52288$var$customerClubStatus.checked && !checkbox.checked) {
        alert(window.theme.strings.marketing_unsubscribe_alert);
        checkbox.checked = true;
        return;
    }
    checkbox.disabled = true;
    button.disabled = true;
    await fetch(`https://konges-sloejd-middleman.vercel.app/api/update-marketing-permission/${theme.customer_club.store}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            customer: window.customer.id,
            email: window.customer.email,
            status: checkbox.checked
        })
    }).then((response)=>response).then(()=>{
        button.disabled = false;
        checkbox.disabled = false;
        $1c4bd05fc0a52288$var$marketingStatus.checked = checkbox.checked;
    });
};
document.querySelector('.marketing-accept-button')?.addEventListener('click', function() {
    $1c4bd05fc0a52288$var$updateMarketingPermission(this, 'marketing-accept');
});
document.querySelector('.club-accept-button')?.addEventListener('click', function() {
    $1c4bd05fc0a52288$var$updateCustomerClub(this, 'customer-club-accept');
});


document.querySelector('.account-header .customer__birthday-add-close')?.addEventListener('click', function() {
    document.querySelector('.address-new-toggle').click();
});


parcelRequire("8582c");
window.addEventListener("load", ()=>{
    let membershipCheckbox = document.getElementById('cherryClub');
    let newsletterCheckbox = document.getElementById('newsletter');
    let btn = document.querySelector('.customer-register .form-field__register-submit');
    function checkboxCheck() {
        if (membershipCheckbox.checked) {
            if (!newsletterCheckbox.checked) {
                if (btn) btn.disabled = true;
                membershipCheckbox.value = "";
            } else {
                if (btn) btn.disabled = false;
                membershipCheckbox.value = "customer_club";
            }
        } else {
            if (btn) btn.disabled = false;
            membershipCheckbox.value = "";
        }
    }
    if (membershipCheckbox && newsletterCheckbox) {
        membershipCheckbox.addEventListener('change', function() {
            checkboxCheck();
        });
        newsletterCheckbox.addEventListener('change', function() {
            checkboxCheck();
        });
    }
});


let $175a08dc8de37958$var$gridList = document.querySelector('.grid');
if ($175a08dc8de37958$var$gridList?.querySelector('.wishlist-block')) {
    let wishlistBlocks = document.querySelectorAll('.wishlist-block.d-none');
    let wishlistBlockTotal = $175a08dc8de37958$var$gridList.dataset.totalBlocks;
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            if (mutation.type === 'attributes' && !mutation.target.hasAttribute(mutation.attributeName)) {
                let referenceBlock = $175a08dc8de37958$var$gridList.querySelector('.product-item');
                let index = 0;
                wishlistBlocks.forEach((block)=>{
                    if (block.dataset.placement) {
                        const existingItem = $175a08dc8de37958$var$gridList.children[parseInt(block.dataset.placement) + parseInt(wishlistBlockTotal) - 1];
                        $175a08dc8de37958$var$gridList.insertBefore(block, existingItem);
                    }
                    wishlistBlockTotal -= 1;
                    block.classList.remove('d-none');
                    block.style.gridColumn = 'span 2';
                    let H = referenceBlock.clientHeight;
                    let W = referenceBlock.clientWidth;
                    let a = (2 * W - 20) / (H / 2);
                    block.querySelector('.image-wrapper').style.setProperty('--aspect-ratio', a);
                    block.querySelector('.image-wrapper').style.setProperty('--aspect-ratio-mobile', a);
                });
            }
        });
    });
    const config = {
        attributes: true,
        attributeOldValue: true,
        subtree: false
    };
    observer.observe($175a08dc8de37958$var$gridList, config);
}


parcelRequire("dKEAy");
const $a5c22171eaaee7b8$var$selectors = {
    open: 'is-open',
    attrs: {
        drawer: 'data-embroidery-drawer',
        underlay: 'data-drawer-underlay',
        openDrawer: 'data-embroidery-drawer-open',
        closeDrawer: 'data-embroidery-drawer-close',
        buyBtn: 'data-add-to-cart',
        embroideryText: 'data-embroidery-text',
        emborideryAddCheckbox: 'data-embroidery-add-checkbox',
        embroideryImageText: 'data-embroidery-image-text'
    }
};
class $a5c22171eaaee7b8$var$EmbroideryDrawer {
    constructor(){
        this.embroideryDrawer = document.querySelector(`[${$a5c22171eaaee7b8$var$selectors.attrs.drawer}]`);
        this.embroideryDrawerButton = document.querySelector(`[${$a5c22171eaaee7b8$var$selectors.attrs.openDrawer}]`);
        this.embroideryDrawerCloseButton = this.embroideryDrawer?.querySelector(`[${$a5c22171eaaee7b8$var$selectors.attrs.closeDrawer}]`);
        this.embroideryDrawerBuyButton = this.embroideryDrawer?.querySelector(`[${$a5c22171eaaee7b8$var$selectors.attrs.buyBtn}]`);
        this.embroideryDrawerText = this.embroideryDrawer?.querySelector(`[${$a5c22171eaaee7b8$var$selectors.attrs.embroideryText}]`);
        this.embroideryDrawerImageText = this.embroideryDrawer?.querySelector(`[${$a5c22171eaaee7b8$var$selectors.attrs.embroideryImageText}]`);
        this.embroideryAddCheckbox = document.querySelector(`[${$a5c22171eaaee7b8$var$selectors.attrs.emborideryAddCheckbox}]`);
        this.productForm = document.querySelector("product-form");
        this.embroideryDrawerIsOpen = false;
        this.onBodyClickEvent = (evt)=>this.onBodyClick(evt);
        this.openEmbroideryDrawer = ()=>this.openEmborideryDrawer(); // override this when calling from event listener
        this.init();
    }
    init() {
        if (!this.embroideryDrawerButton) return;
        //set form to button
        this.embroideryDrawerBuyButton.setAttribute('form', this.productForm.querySelector("form").getAttribute("id"));
        this.embroideryDrawerText.setAttribute('form', this.productForm.querySelector("form").getAttribute("id"));
        this.embroideryAddCheckbox.setAttribute('form', this.productForm.querySelector("form").getAttribute("id"));
        this.embroideryDrawerBuyButton.addEventListener("click", (e)=>{
            e.preventDefault();
            document.dispatchEvent(new CustomEvent("theme:cart:add", {
                detail: {
                    button: this.productForm.querySelector("[data-add-to-cart]")
                },
                bubbles: false
            }));
            this.closeEmbroideryDrawer();
        });
        const _this = this;
        this.embroideryDrawerButton.addEventListener("click", function() {
            _this.toggleEmbroideryDrawer();
        });
        this.embroideryDrawerCloseButton.addEventListener("click", function() {
            _this.closeEmbroideryDrawer();
        });
        this.embroideryDrawerText.addEventListener("keyup", function(event) {
            _this.onEmbroideryTextChange(event);
        });
    }
    onEmbroideryTextChange(event) {
        this.embroideryDrawerImageText.textContent = event.target.value;
        if (event.target.value == "") this.embroideryDrawerImageText.textContent = "text";
    }
    onBodyClick(event) {
        if (event.target.hasAttribute($a5c22171eaaee7b8$var$selectors.attrs.underlay)) this.closeEmbroideryDrawer();
    }
    closeEmbroideryDrawer() {
        if (!this.embroideryDrawer) return;
        if (!this.embroideryDrawer.classList.contains($a5c22171eaaee7b8$var$selectors.open)) return;
        this.embroideryDrawerBuyButton.removeAttribute('form');
        this.embroideryDrawerText.removeAttribute('form');
        this.embroideryAddCheckbox.checked = false;
        this.embroideryAddCheckbox.removeAttribute('form');
        this.embroideryDrawerIsOpen = false;
        document.dispatchEvent(new CustomEvent("theme:embroidery:close", {
            bubbles: true
        }));
        // Cart elements animation reset
        this.embroideryDrawer.classList.remove($a5c22171eaaee7b8$var$selectors.open);
        document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
            bubbles: true
        }));
    }
    openEmborideryDrawer() {
        if (!this.embroideryDrawer || this.embroideryDrawerIsOpen) return;
        this.embroideryDrawerBuyButton.setAttribute('form', this.productForm.querySelector("form").getAttribute("id"));
        this.embroideryDrawerText.setAttribute('form', this.productForm.querySelector("form").getAttribute("id"));
        this.embroideryAddCheckbox.setAttribute('form', this.productForm.querySelector("form").getAttribute("id"));
        this.embroideryAddCheckbox.checked = true;
        this.embroideryDrawerImageText.textContent = "text";
        document.body.addEventListener("click", this.onBodyClickEvent);
        document.dispatchEvent(new CustomEvent("theme:embroidery:open", {
            bubbles: !0
        }));
        document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
            bubbles: !0
        }));
        this.embroideryDrawer.classList.add($a5c22171eaaee7b8$var$selectors.open);
        this.embroideryDrawerIsOpen = true;
    }
    toggleEmbroideryDrawer() {
        if (!this.embroideryDrawerIsOpen) this.openEmbroideryDrawer();
        else this.closeEmbroideryDrawer();
    }
}
const $a5c22171eaaee7b8$var$embroideryDrawer = new $a5c22171eaaee7b8$var$EmbroideryDrawer();


const $0211d30208e8516e$var$form = document.getElementById('gift-guide-filter-form');
const $0211d30208e8516e$var$filterOption = document.querySelectorAll('.gift-guide-filter-options-option');
for (const option of $0211d30208e8516e$var$filterOption)option.addEventListener('click', function() {
    const input = this.querySelector('input');
    input.checked = !input.checked;
    $0211d30208e8516e$var$form.submit();
});
document.addEventListener('theme:range:update', function() {
    $0211d30208e8516e$var$form.submit();
});
const $0211d30208e8516e$var$closeIcon = document.querySelector('.gift-guide-filter-close');
const $0211d30208e8516e$var$filter = document.querySelector('.gift-guide-filter');
const $0211d30208e8516e$var$openButton = document.querySelector('.gift-guide-filter-open button');
const $0211d30208e8516e$var$openButtonDiv = document.querySelector('.gift-guide-filter-open');
$0211d30208e8516e$var$closeIcon?.addEventListener('click', function() {
    $0211d30208e8516e$var$filter?.classList.remove('active');
    $0211d30208e8516e$var$openButtonDiv?.classList.add('active');
});
$0211d30208e8516e$var$openButton?.addEventListener('click', function() {
    $0211d30208e8516e$var$filter?.classList.add('active');
    $0211d30208e8516e$var$openButtonDiv?.classList.remove('active');
});


class $eb3b733982b2bcca$var$HeaderDropdown extends HTMLElement {
    constructor(){
        super();
        this.dropdownNode = this.querySelector('.header__dropdown__wrapper');
    }
    connectedCallback() {
        if (this.dropdownNode) {
            const navlinksNodeHeight = this.handleDropdownItemsHeights(this.dropdownNode);
            this.handleDropdownItemsHeightsWider(this.dropdownNode, navlinksNodeHeight);
            const resizeObserver = new ResizeObserver(()=>{
                const menuBlockNodes = this.dropdownNode.querySelectorAll('.menu__block');
                let maxHeight = 0;
                // Find the tallest item
                menuBlockNodes.forEach((menuBlockNode)=>{
                    const imageWrapperNode = menuBlockNode.querySelector('.image-wrapper');
                    if (imageWrapperNode) maxHeight = Math.max(maxHeight, imageWrapperNode.offsetHeight);
                    menuBlockNodes.forEach((menuBlockNode)=>{
                        const imageWrapperNode = menuBlockNode.querySelector('.image-wrapper');
                        if (imageWrapperNode) imageWrapperNode.style.height = `${maxHeight}px`;
                    });
                });
            });
            resizeObserver.observe(this.dropdownNode);
        }
    }
    handleDropdownItemsHeights(dropdownNode) {
        /*
      This function adjusts the height of image wrapper elements inside 
      a dropdown menu to match the height of the .dropdown__family navigation 
      links container.
    */ const navLinksNode = dropdownNode.querySelector('.dropdown__family');
        if (!navLinksNode) return;
        // Get height without padding and margin
        const computedStyle = window.getComputedStyle(navLinksNode);
        const paddingTop = parseFloat(computedStyle.paddingTop);
        const paddingBottom = parseFloat(computedStyle.paddingBottom);
        let navlinksNodeHeight = navLinksNode.offsetHeight;
        navlinksNodeHeight = navlinksNodeHeight - paddingTop - paddingBottom;
        const menuBlockNodes = dropdownNode.querySelectorAll('.menu__block');
        if (!menuBlockNodes) return;
        menuBlockNodes.forEach((menuBlockNode)=>{
            const imageWrapperNode = menuBlockNode.querySelector('.image-wrapper');
            if (imageWrapperNode) {
                if (imageWrapperNode.offsetHeight < navlinksNodeHeight) imageWrapperNode.style.height = navlinksNodeHeight + 'px';
            }
        });
        return navlinksNodeHeight;
    }
    handleDropdownItemsHeightsWider(dropdownNode, navlinksNodeHeight) {
        /*
      This function ensures that all .image-wrapper elements inside .menu__block elements 
      have the same height as the widest navigation image (.menu__block--wide), 
      but only if it is taller than the height of the navlinks height.
    */ const menuBlockNodes = dropdownNode.querySelectorAll('.menu__block');
        if (!menuBlockNodes) return;
        let menuBlockWiderHeight = 0;
        menuBlockNodes.forEach((menuBlockNode)=>{
            if (menuBlockNode.classList.contains('menu__block--wide')) menuBlockWiderHeight = menuBlockNode.offsetHeight;
        });
        if (menuBlockWiderHeight > navlinksNodeHeight) menuBlockNodes.forEach((menuBlockNode)=>{
            const imageWrapperNode = menuBlockNode.querySelector('.image-wrapper');
            if (imageWrapperNode) imageWrapperNode.style.height = menuBlockWiderHeight + 'px';
        });
    }
}
customElements.define("header-dropdown", $eb3b733982b2bcca$var$HeaderDropdown);


class $f8c3ea2cdf0336c8$var$CustomContent extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.showSection = this.querySelector("[data-show-section]")?.dataset.showSection;
        this.handleSectionVisibility(this.showSection);
    }
    handleSectionVisibility(showSection) {
        const section = this.querySelector("section");
        if (!section) return;
        // If the block that contains the section visibility toggle does not exist, display the section
        if (!showSection || showSection == 'true') section.classList.remove("d-none");
    }
}
customElements.define("custom-content", $f8c3ea2cdf0336c8$var$CustomContent);



})();
//# sourceMappingURL=parcel_scripts.js.map
